import CusAdmob from '@common/components/Admob';
import CusDatePicker from '@common/components/DatePicker';
import CusFileUpload from '@common/components/FileUpload';
import CusFrom from '@common/components/Form';
import CusGroup from '@common/components/Group';
import CusImage from '@common/components/Image';
import CusImageUpload from '@common/components/ImageUpload';
import CusInput from '@common/components/Input';
import CusLabel from '@common/components/Label';
import CusLibraryComponent from '@common/components/LibraryComponent';
import CusList from '@common/components/List';
import CusPassword from '@common/components/Password';
import CusQuestion from '@common/components/Question';
import CusRectangle from '@common/components/Rectangle';
import CusSelect from '@common/components/Select';
import CusTable from '@common/components/Table/index';
import CusVimeo from '@common/components/Vimeo';
import WebView from '@common/components/WebView';
import CusYoutube from '@common/components/Youtube';
import { HEIGHT_STATUS_BAR } from '@common/constants/shared';
import { appInfoSelector } from '@common/redux/selectors/app';
import { pagesSelector } from '@common/redux/selectors/page';
import { useLocation } from '@common/routes/hooks';
import BindingComponent from '@common/screens/RenderScreen/BindingComponent';
import {
  getComponentChild,
  mapPropColor,
} from '@common/screens/RenderScreen/utils';
import {
  ComponentType,
  ElementType,
  ObjectRenderProps,
} from '@common/types/element';
import { find, get, isNil, sortBy } from 'lodash';
import qs, { ParsedQuery } from 'query-string';
import React, { FC, Fragment, useMemo } from 'react';
import { Platform, View } from 'react-native';
import { useSafeAreaInsets } from 'react-native-safe-area-context';
import { useSelector } from 'react-redux';
// import { getComponentIds } from '@common/utils/component';
import CusImageUploadList from '@common/components/ImageUploadList';
// import CusCustomerChat from '@common/components/CustomerChat';
import CusInvisibleShape from '@common/components/InvisibleShape';
import { dimensionSelector } from '@common/redux/selectors/page';

export const mapping: Record<string, any> = {
  [ComponentType.input]: CusInput,
  [ComponentType.label]: CusLabel,
  [ComponentType.rectangle]: CusRectangle,
  [ComponentType.image]: CusImage,
  [ComponentType.libraryComponent]: CusLibraryComponent,
  [ComponentType.password]: CusPassword,
  [ComponentType.select]: CusSelect,
  [ComponentType.datePicker]: CusDatePicker,
  [ComponentType.list]: CusList,
  [ComponentType.form]: CusFrom,
  [ComponentType.youtube]: CusYoutube,
  [ComponentType.vimeo]: CusVimeo,
  [ComponentType.admob]: CusAdmob,
  [ComponentType.imageUpload]: CusImageUpload,
  [ComponentType.fileUpload]: CusFileUpload,
  [ComponentType.group]: CusGroup,
  [ComponentType.webView]: WebView,
  [ComponentType.table]: CusTable,
  [ComponentType.question]: CusQuestion,
  [ComponentType.imageUploadList]: CusImageUploadList,
  // [ComponentType.customerChat]: CusCustomerChat,
  [ComponentType.web3List]: CusList,
  [ComponentType.invisibleShape]: CusInvisibleShape,
};

const notScaleComponent = [
  ComponentType.image,
  ComponentType.group,
  ComponentType.rectangle,
  ComponentType.imageUpload,
];

const ObjectRender = ({
  arrComp,
  isScreen,
  layout,
  keyItem,
  isShowStatusBar,
  screen,
}: ObjectRenderProps) => {
  const dimension = useSelector(dimensionSelector);
  const appInfo = useSelector(appInfoSelector);

  const insets = useSafeAreaInsets();

  const { search } = useLocation();

  const query: ParsedQuery<any> = qs.parse(search);

  const pages = useSelector(pagesSelector);

  const currentPageInfo = useMemo(
    () =>
      screen
        ? screen
        : pages.find((o) => {
            return (
              o.screenId.toString() == get(query, 'target', null) ||
              o.screenUuid == query?.target
            );
          }),
    [query, screen]
  );

  // const pageModalInfo = useMemo(
  //   () =>
  //     pages.find((o) => {
  //       return (
  //         o.screenId.toString() == get(query, 'targetModal', null) ||
  //         o.screenUuid == query?.targetModal
  //       );
  //     }),
  //   [query]
  // );

  // const modalMetadata = pageModalInfo?.metadata
  //   ? JSON.parse(pageModalInfo.metadata)
  //   : [];

  const originX = currentPageInfo ? dimension.width / currentPageInfo.width : 0;
  const originY = currentPageInfo
    ? dimension.height / currentPageInfo.height
    : 0;

  const isWeb = useMemo(() => appInfo?.platform === 'web', [appInfo]);

  let offsetLeft = layout?.offsetLeft || 0;
  let offsetTop = layout?.offsetTop || 0;
  let sortArrComp: ElementType[] = sortBy(arrComp, ['y', 'x']);

  if (!sortArrComp.length) return <Fragment />;

  let res = [];

  const metadata = currentPageInfo
    ? sortBy(
        typeof currentPageInfo.metadata === 'string'
          ? JSON.parse(currentPageInfo.metadata)
          : currentPageInfo.metadata,
        'y'
      )
    : [];

  for (let i = 0; i < sortArrComp.length; i++) {
    let obj = JSON.parse(JSON.stringify(sortArrComp[i])),
      prevObj = sortArrComp[i - 1];

    // get function on sortArrComp[i]
    obj = {
      ...obj,
      ...(screen?.screenUuid && { screenUuid: screen?.screenUuid }),
      setEnableScrollViewScroll: sortArrComp[i].setEnableScrollViewScroll,
    };

    let newAttributes = { ...mapPropColor(obj?.attributes, appInfo) };

    obj = {
      ...obj,
      attributes: { ...obj?.attributes, ...newAttributes },
    };

    const statusBarHeight = isWeb ? 0 : HEIGHT_STATUS_BAR * originX;

    if (i == 0) {
      const marginTopPocth =
        insets.bottom + Platform.OS !== 'ios' && obj.y < statusBarHeight
          ? statusBarHeight - obj?.y || 0
          : 0;

      obj.marginTop = !isScreen
        ? obj.y - offsetTop
        : obj.y + (isShowStatusBar ? -statusBarHeight + marginTopPocth : 0);
    } else {
      let marginTop =
        notScaleComponent.includes(prevObj?.type) && !isWeb
          ? (obj.y - prevObj.y - prevObj.height / originX) * originX
          : obj.y - prevObj.y - prevObj.height;
      obj.marginTop = marginTop;
    }

    // set marginLeft and width component and merge to originX
    if (obj?.screenWidth != dimension.width) {
      obj.resizeMode = obj?.screenWidth ? true : false;
      obj.screenWidth = dimension.width;
      obj.originX = originX;
      obj.originY = originY;

      let scaleWidth = obj.width * originX;

      if (isWeb) {
        obj.isWeb = isWeb;
        if (obj.width / (currentPageInfo?.width || 1) >= 0.9) {
          obj.width = obj.width * originX;
          scaleWidth = obj.width;
        } else if (obj.width / dimension.width >= 0.9) {
          obj.width = dimension.width * 0.9;
          scaleWidth = obj.width;
        }
      } else {
        if (notScaleComponent.includes(obj?.type)) {
          obj.width = obj.width * originX;
          // obj.height = obj.height * originX;
        } else {
          obj.width = obj.width * originX;
        }
      }

      let webOffset = 0;

      if (isWeb) {
        webOffset = (scaleWidth - obj.width) / 2;
      } else {
        webOffset = notScaleComponent.includes(obj?.type)
          ? (scaleWidth - obj.width) / 2
          : 0;
      }

      if (isNil(layout?.offsetLeft)) {
        obj.marginLeft =
          obj.x === 0 ? 0 : (obj.x - offsetLeft) * originX + webOffset;
      } else {
        obj.marginLeft = obj.x - offsetLeft;

        const objTopRight = obj.x + obj.width;
        const parentTopRight =
          (layout?.offsetLeft || 0) + (layout?.parentWidth || 0);
        if (objTopRight >= parentTopRight) {
          obj.marginLeft = obj.marginLeft - (objTopRight - parentTopRight);

          if (obj.marginLeft < 0) {
            obj.marginLeft = 0;
          }
        }
      }
    } else {
      obj.resizeMode = false;
    }

    let ObjectClass = mapping[obj.type] as FC;
    if (!ObjectClass) {
      console.log(`I don't know how to render ${obj.name}`);
      return <React.Fragment></React.Fragment>;
    } else {
      if (obj?.fixPosition == 'top' && isScreen) {
        delete obj.marginTop;
        const left = obj.marginLeft;
        const zIndex = obj.zIndex;
        delete obj.marginLeft;
        //delete obj.zIndex;
        res.push(
          <View
            style={{
              top: obj.y * originY,
              left,
              zIndex,
              position: 'absolute',
            }}
            key={i}
          >
            <BindingComponent key={i} obj={obj} ObjectClass={ObjectClass} />
          </View>
        );
      } else if (obj?.fixPosition == 'bottom' && isScreen) {
        delete obj.marginTop;
        const left = obj.marginLeft;
        const zIndex = obj.zIndex;
        delete obj.marginLeft;
        // delete obj.zIndex;
        res.push(
          <View
            style={{
              bottom: currentPageInfo
                ? (currentPageInfo.height - obj.height - obj.y) * originY
                : 0,
              left,
              zIndex,
              position: 'absolute',
            }}
            key={i}
          >
            <BindingComponent key={i} obj={obj} ObjectClass={ObjectClass} />
          </View>
        );
      } else {
        res.push(
          <BindingComponent key={i} obj={obj} ObjectClass={ObjectClass} />
        );
      }
    }
  }

  return <React.Fragment>{res}</React.Fragment>;
};

export default ObjectRender;
